<template>
  <div>
    <div class="c-title-wrap mar-top-40">
      <p class="c-title">基本信息</p>
    </div>
    <!-- 原创文章 -->
    <article-source
      :articleSource.sync="source"
      :disabled.async="articelDisabled"
      :words.async="words"
      :articleType.async="articleType"
      @repeatGetRecord="handleClick"
    />
    <slot></slot>
    <div class="content-item flex" v-if="showShareFloor?.show">
      <p><span class="red">*</span>{{ showShareFloor?.floorDesc }}</p>
      <el-radio-group v-model="canShare" @change="canShareChange">
        <el-radio
          v-for="item in showShareFloor?.contentAttributeBizDTOS"
          :label="item.dictionarySort === 2 ? true : false"
          >{{ item.desc }}</el-radio
        >
      </el-radio-group>
    </div>
    <!--    内容分发-->
    <div class="content-item flex">
      <p>
        <span class="red">*</span>{{ distributeInformationFloor.floorDesc }}
      </p>
      <el-radio-group
        v-model="distributeExtension"
        class="flex align-items-center radio-item"
        v-for="(
          radioItem, id
        ) in distributeInformationFloor.contentAttributeBizDTOS"
        :key="id"
        @change="distributeChange"
      >
        <el-radio
          :label="radioItem.id"
          :disabled="radioItem.disable || articelDisabled"
          >{{ radioItem.desc }}</el-radio
        >
      </el-radio-group>
      <div
        v-if="distributeExtension == 26"
        slot="tip"
        class="el-upload__tip"
        style="color: #ff9b39; margin-left: 28px; margin-top: 0"
      >
        对外推广的文章会进入分发市场中，“隐私”业务无法对外推广
      </div>
    </div>
    <div class="content-item flex" v-if="distribute">
      <p style="visibility: hidden"><span class="red">*</span></p>
      <el-radio-group
        v-model="extensionSecondLevel"
        class="flex align-items-center radio-item"
        v-for="(item, index) in distributeChildren"
        :key="index"
      >
        <el-radio
          v-if="
            articleType == 7 &&
            item.id == 30 &&
            resForm.contentExtend &&
            !resForm.contentExtend.syncToJdDr
          "
          :label="item.id"
          :disabled="item.disabled || articelDisabled"
        >
          <!-- 未同步时(存在contentExtend字段表示为新版，!syncToJdDr为未同步) 只显示京东健康（30） -->
          {{ item.desc }}
        </el-radio>
        <el-radio
          v-if="
            articleType == 7 &&
            ((resForm.contentExtend && resForm.contentExtend.syncToJdDr) ||
              !resForm.contentExtend)
          "
          :label="item.id"
          :disabled="item.disabled || articelDisabled"
        >
          <!-- 同步时 正常显示 -->
          {{ item.desc }}
        </el-radio>
        <el-radio
          v-if="articleType !== 7"
          :label="item.id"
          :disabled="item.disabled || articelDisabled"
          >{{ item.desc }}</el-radio
        >
      </el-radio-group>
    </div>
    <!-- 内容索引 -->
    <div class="content-item flex">
      <p><span class="red">*</span>内容索引</p>
      <el-cascader
        v-model="indexSelect"
        :disabled="articelDisabled"
        :props="indexProps"
        :multiple="false"
        :options="indexTreeList"
        @change="handleChange"
      ></el-cascader>
    </div>
    <!--内容质量-->
    <div class="content-item flex">
      <p>内容质量</p>
      <!-- <p>{{ natureInformationFloor.floorDesc }}</p> -->
      <!-- <p><span class="red">*</span>{{ natureInformationFloor.floorDesc }}</p> -->
      <!-- <el-radio-group
        v-model="natureExtension"
        class="flex align-items-center radio-item"
        v-for="(
          radioItem, id
        ) in natureInformationFloor.contentAttributeBizDTOS"
        :key="id"
        @change="natureChange"
      >
        <el-radio
          :label="radioItem.id"
          :disabled="radioItem.disable || articelDisabled"
          >{{ radioItem.desc }}</el-radio
        >
      </el-radio-group> -->
      <div style="display: flex; flex-direction: column" v-if="!isShow">
        <div
          v-for="(radioItem, id) in natureInformationFloor"
          :key="id"
          style="display: flex; width: 600px; height: 40px"
        >
          <div style="flex: 1">{{ radioItem.desc }}</div>
          <el-radio-group
            style="display: flex; width: 200px"
            v-model="form.radioArray[id]"
          >
            <el-radio
              v-for="item in radioItem.children"
              v-model="radioItem.checked"
              :label="item.code"
              :key="item.code"
              @change="handleRadioChanges(radioItem, item.code)"
              >{{ item.desc }}</el-radio
            >
          </el-radio-group>
        </div>
        <div style="display: flex; align-items: center">
          <div style="width: 100px">最终质量</div>
          <el-radio-group v-model="natureExtension">
            <el-radio
              v-for="item in allTypeList"
              :key="item.id"
              :label="item.code * 1"
              :disabled="
                reslist.length < natureInformationFloor.length &&
                (item.code == '1' || item.code == '5')
              "
              @change="testLever(item, item.code)"
              >{{ item.desc }}</el-radio
            >
          </el-radio-group>
          <div v-if="natureExtension === 100">
            <span style="vertical-align: text-bottom">：{{ tipTool }}</span>
          </div>
        </div>
      </div>

      <!-- 业务最终质量 -->
      <!-- <p>{{ natureInformationFloor.floorDesc }}</p> -->
      <!-- <p><span class="red">*</span>{{ natureInformationFloor.floorDesc }}</p> -->
      <div v-if="isShow" style="display: flex">
        <el-radio-group
          v-model="fansity"
          class="flex align-items-center radio-item"
          v-for="(radioItem, id) in finalQuliaty"
          :key="id"
          @change="natureChange"
        >
          <el-radio
            :label="radioItem.code"
            :disabled="radioItem.disable || articelDisabled"
            >{{ radioItem.desc }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <!-- <div class="content-item flex">
      <p style="visibility: hidden"><span class="red">*</span></p>
      <el-radio-group
        v-model="natureSecondLevel"
        class="flex align-items-center radio-item"
        v-for="(item, index) in natureChildren"
        :key="index"
      >
        <el-radio
          :label="item.id"
          :disabled="item.disabled || articelDisabled"
          >{{ item.desc }}</el-radio
        >
      </el-radio-group>
    </div> -->
  </div>
</template>

<script>
var app_type = process.env.VUE_APP_TYPE;
import { basicInformationFloor } from "@/api/contentDistribution";
import { manListContentIndexTree } from "@/api/indexs";
import ArticleSource from "@/components/radio/ArticleSource";
import { getMockDes, prdata } from "./mock";
import { form_bak } from "@/utils/tools";
import { request } from "@/utils/axios";
export default {
  name: "ArticleBasic",
  props: [
    "canShare",
    "articleSource",
    "articleLevel",
    "articelId",
    "articleType",
    "words",
    "articelRadio",
    "articelDisabled",
    "floorType",
    "articleOriginality",
    "originalityCheckTime",
    "articleOriginalityText",
    "articleIndex",
    "title",
    "resArticleType",
    "content",
    "resForm",
    "textLength",
    "editorEdit",
  ],
  computed: {
    source: {
      get() {
        console.log("this.articleSource", this.articleSource);
        return this.articleSource;
      },
      set(val) {
        this.$emit("update:articleSource", val);
      },
    },
    indexSelect: {
      get() {
        console.log(this.articleIndex);
        return this.articleIndex;
      },
      set(val) {
        this.$emit("update:articleIndex", val);
      },
    },
    myForm: {
      get() {
        return this.resForm;
      },
      set(val) {
        this.$emit("update:resForm", val);
      },
    },
  },
  components: {
    ArticleSource,
  },
  data() {
    return {
      app_type,
      distributeExtension: 26,
      extensionSecondLevel: 30,
      // natureExtension: 3,
      natureExtension: 100,
      fansity: 1,
      natureSecondLevel: 20,
      distributeNature: 1,
      distributeSecondLevel: 1,
      distribute: true,
      distributeInformationFloor: [],
      showShareFloor: {},
      natureInformationFloor: [],
      distributeChildren: [],
      natureChildren: [],
      indexTreeList: [],
      indexProps: {
        value: "indexId",
        label: "name",
        children: "contentIndexes",
      },
      score: [],
      mockData: {},
      total: 0,
      contentAttributes: [],
      form: {
        radioArray: [],
      },
      // 最后的入参
      reslist: [],
      // 文章最终质量
      finalQuliaty: [],
      // 另类的分数
      otherSource: ["1", "2", "3"],
      isShow: false,
      // 选择的最终质量
      checkFinal: [],
      // 优秀，良好，一般
      typeList: [],
      // 全部
      allTypeList: [],
      otherScore: 0,
      cEditor: 0,
      videoScore: 0,
      tipTool: "",
    };
  },
  watch: {
    checkList(newVal, oldVal) {
      // console.log("数值变化",newVal)
    },
    resForm: {
      deep: true,
      handler(newVal, oldVal) {
        this.otherScore = 0;
        this.videoScore = 0;
        if (newVal.articleSource == 1) {
          this.otherScore += 0.4;
        }
        if (newVal.title.length >= 10 && newVal.title.length <= 25) {
          this.otherScore += 0.4;
        }
        if (this.articleType == 7) {
          setTimeout(() => {
            let du = document.getElementsByTagName("video")[0];
            if (du?.duration >= 1 && du?.duration <= 180) {
              this.videoScore += 0.4;
            }
          }, 200);
        }
        // this.countSource(this.reslist);
      },
    },
    editorEdit: {
      deep: true,
      handler(newVal, oldVal) {
        console.log("(newVal,oldVal", newVal, oldVal);
        this.cEditor = 0;
        // 段落字数
        if ((this.textLength || this.myForm.content.length) >= 800) {
          this.cEditor += 0.4;
        }

        // 图片个数
        if (newVal?.editor?.match(/<img.*?(?:>|\/>)/gi)?.length >= 2) {
          // console.log("图片个数",newVal?.editor?.match(/<img.*?(?:>|\/>)/gi)?.length, this.myForm?.content.match(/<img(?:(?!\/>).|\n)*?\/>/gm)?.length )
          this.cEditor += 0.4;
        }

        // 段落个数
        if (
          newVal?.editor?.match(/<p(?:(?!<\/p>).|\n)*?<\/p>/gm)?.length >= 3
        ) {
          // console.log("段落个数",newVal?.editor?.match(/<p(?:(?!<\/p>).|\n)*?<\/p>/gm)?.length, this.myForm?.content?.match(/<p(?:(?!<\/p>).|\n)*?<\/p>/gm)?.length )
          this.cEditor += 0.4;
        }
        console.log("this.cEditor", this.cEditor);
        // this.countSource(this.reslist);
      },
    },
  },
  created() {
    this.isShow = window.location.pathname == "/contentDistribution/articles";
    // 获取内容质量枚举
    this.queryDictionaries1();
    this.getInformationFloor();
    this.getIndexTreeList();
    this.$parent.searchArticleById().then(() => {
      if (this.$parent.res.contentAttributes) {
        this.$parent.res.contentAttributes.map((item) => {
          console.log("item", item);
          if (item.typeDesc == "内容分发") {
            this.distributeExtension = item.id;
            if (item.parentId) {
              // 是否是对外公开
              this.extensionSecondLevel = item.id; // 分发下所有
              this.distributeExtension = item.parentId;
            }
          }
          // if (item.typeDesc == "内容质量") {
          //   this.natureExtension = item.id;
          // }
          // 如果为不对外公开
          if (this.distributeExtension == 27) {
            this.distributeChildren = [];
            this.distribute = false;
            this.extensionSecondLevel = null;
          }
          // 如果不是科普知识
          // if (this.natureExtension != 18) {
          //   this.natureChildren = [];
          //   this.natureSecondLevel = null;
          // }
        });
      }
    });
  },
  methods: {
    // 获取最终判断
    async queryDictionaries1() {
      try {
        await request("health_cmp_queryDictionaries", {
          tenantId: this.$commonJs.getTenantId(),
          typeList: [29],
          contentId: this.$router.history.current.query.id,
        }).then((res) => {
          if (res) {
            console.log("最终质量", res);
            // 回显最终质量
            // this.natureExtension = res.find(item => item.checked).code;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    // 回显单选框数据
    handCheck() {
      const temp = [];
      this.natureInformationFloor.forEach((item, index) => {
        item.children.forEach((it) => {
          if (it.checked) {
            temp.push(it.code);
            this.reslist.push(it);
          }
        });
        if (temp.length !== index + 1) {
          temp.push(null);
        }
      });
      this.form.radioArray = temp;
    },

    // 单选框选择
    handleRadioChanges(item, id) {
      item.children.forEach((res) => {
        if (res.code === id) {
          res.checked = true;
          this.reslist.push(res);
        } else {
          res.checked = false;
        }
      });
      let newArry = this.reslist;
      //数组去重选择最后一条数据
      // for(var i=0;i<newArry.length;i++){
      //   for(var j=i+1;j<newArry.length;j++){
      //     if(newArry[i].parentId==newArry[j].parentId){
      //       newArry.splice(i,1);
      //       j--;
      //     }
      //   }
      // }
      // console.log("newArry",newArry)
      if (newArry.length >= this.natureInformationFloor.length) {
        this.countSource(this.duplicate(newArry));
      }
      this.reslist = this.duplicate(newArry);
      // this.contentAttributes = newArry
    },
    // 数组去重
    duplicate(newArry) {
      for (var i = 0; i < newArry.length; i++) {
        for (var j = i + 1; j < newArry.length; j++) {
          if (newArry[i].parentId == newArry[j].parentId) {
            newArry.splice(i, 1);
            j--;
          }
        }
      }
      return newArry;
    },
    // 最终质量的选择
    testLever(item, code) {
      item.checked = true;
      let arr = [item];
      if (code == 100) {
        arr = this.typeList.filter((item) => item.checked);
      }
      this.checkFinal = arr;
    },

    // 算分
    countSource(arr) {
      let count = 0;
      arr.forEach((item) => {
        if (item.checked) {
          if (item.desc == "符合") {
            if (item.type == 31 && this.otherSource.includes(item.code)) {
              count += 0.4;
            } else {
              count += 1;
            }
          }
        }
      });
      if ((this.articleType || this.resArticleType) == 7) {
        setTimeout(() => {
          count += this.videoScore + this.otherScore;
        }, 300);
      } else {
        count += this.otherScore + this.cEditor;
      }
      console.log("count", count.toFixed(1));
      this.score = count.toFixed(1);
      if (count >= 8) {
        this.natureExtension = 5;
        this.checkFinal = this.finalQuliaty?.filter((item) => item.code == "5");
      } else if (count <= 3) {
        this.natureExtension = 1;
        this.checkFinal = this.finalQuliaty?.filter((item) => item.code == "1");
      } else {
        this.natureExtension = 100;
        this.checkFinal = this.finalQuliaty?.filter(
          (item) => item.code === 100
        );
      }
    },

    getInformationFloor() {
      basicInformationFloor({
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articelId,
        contentType: 1,
        requestSource: this.floorType || 1,
      }).then((res) => {
        if (res) {
          let arr = [{ code: 100, id: 100, desc: "系统判断" }];
          this.distributeInformationFloor = res[0]; // 分发
          // this.natureInformationFloor = res[1]; // 内容质量
          if ((this.articleType || this.resArticleType) == 7) {
            this.natureInformationFloor = res[2].contentAttributeBizDTOS;
          } else {
            this.natureInformationFloor = res[1].contentAttributeBizDTOS;
          }
          this.showShareFloor = res[4];
          // 处理最终质量数据
          res[res.length - 1].contentAttributeBizDTOS.map((item) => {
            if (["2", "3", "4"].includes(item.code)) {
              this.typeList.push(item);
              if (item.checked) {
                this.natureExtension = 100;
              }
            } else {
              if (item.checked) {
                this.natureExtension = Number(item.code);
              }
              arr.unshift(item);
            }
          });
          const val = this.typeList.filter((item) => item.checked);
          this.tipTool = val.length > 0 ? val[0].desc : "暂无";
          this.allTypeList = arr;
          this.finalQuliaty = res[res.length - 1].contentAttributeBizDTOS;
          if (this.finalQuliaty) {
            this.fansity = this.finalQuliaty.filter(
              (item) => item.checked
            )?.[0]?.code;
            this.checkFinal = this.finalQuliaty.filter((item) => item.checked);
          }
          this.handCheck();
          this.distributeChildren =
            res[0].contentAttributeBizDTOS[0].children || []; // 分发子级
          this.natureChildren =
            res[1].contentAttributeBizDTOS[0].children || []; // 性质子级
          res[0].contentAttributeBizDTOS.map((item) => {
            if (item.disable) {
              this.distributeExtension = 27;
              this.extensionSecondLevel = null;
              this.distributeChildren = []; // 分发子级
              this.distribute = false;
            }
            if (item.checked) {
              this.distributeExtension = item.id;
            } else {
              this.distributeExtension = 26;
            }
          });
          if (this.natureExtension != 18) {
            this.natureChildren = [];
            this.natureSecondLevel = null;
          }
        }
      });
    },
    handleClick(arg, type) {
      this.$emit("repeatGetRecord", arg, type);
    },
    handleChange(val) {
      this.$emit("indexChange", val);
    },
    canShareChange(val) {
      this.$emit("canShareChange", val);
    },
    distributeChange(val) {
      if (val == 27) {
        this.extensionSecondLevel = null;
        this.distribute = false;
      } else {
        this.distribute = true;
        this.extensionSecondLevel = 30;
      }
      this.distributeInformationFloor.contentAttributeBizDTOS.map((item) => {
        if (val == item.id) {
          this.distributeChildren = item.children || [];
        }
      });
    },
    natureChange(val, pitem) {
      // if (val != 18) {
      //   this.natureSecondLevel = null;
      // } else {
      //   this.natureSecondLevel = 20;
      // }
      // this.natureInformationFloor.contentAttributeBizDTOS.map((item) => {
      //   if (val == item.id) {
      //     this.natureChildren = item.children || [];
      //   }
      // });
      // let obj = {
      //   [sitem?.id] : val == 1 ? `true+${sitem?.source}` : `false+${pitem?.source}`
      // };
      // console.log("组装数组",obj);
      // this.checkList = {...this.checkList,  ...obj};
      // console.log("this.checkList",this.checkList);
      // if(Object.keys(this.checkList).length == this.natureInformationFloor?.contentAttributeBizDTOS?.length) {
      //   let all = 0;
      //   Object.keys(this.checkList).map(item => {
      //     let temp = this.checkList[item].split("+");
      //     console.log("temp",0 + Number(temp[1]));
      //     if(temp[0] === "true") {
      //       all = all += Number(temp[1])
      //     }
      //   })
      //   this.total = this.total + Number(all.toFixed(1));
      //   console.log("this.total",this.total)
      // }
    },
    dataProcessing() {
      let arr = [];
      // 分发数据处理
      this.distributeInformationFloor.contentAttributeBizDTOS.map((item) => {
        if (this.distributeExtension == item.id) {
          let parent = {
            code: item.code,
            type: item.type,
          };
          arr.push(parent);
        }
        if (item.children) {
          item.children.map((childItem) => {
            if (this.extensionSecondLevel == childItem.id) {
              let children = {
                code: childItem.code,
                type: childItem.type,
              };
              arr.push(children);
            }
          });
        }
      });
      // 性质数据处理
      // this.natureInformationFloor.contentAttributeBizDTOS.map((item) => {
      //   if (this.natureExtension == item.id) {
      //     let parent = {
      //       code: item.code,
      //       type: item.type,
      //     };
      //     arr.push(parent);
      //   }
      //   if (item.children) {
      //     item.children.map((childItem) => {
      //       if (this.natureSecondLevel == childItem.id) {
      //         let children = {
      //           code: childItem.code,
      //           type: childItem.type,
      //         };
      //         arr.push(children);
      //       }
      //     });
      //   }
      // });

      // 性质数据处理
      if (this.natureInformationFloor.length > 0) {
        arr = [...arr, ...this.reslist, ...this.checkFinal];
        console.log("arr", arr);
      }
      // this.natureInformationFloor.map((item) => {

      // if (this.natureExtension == item.id) {
      //   let parent = {
      //     code: item.code,
      //     type: item.type,
      //   };
      //   arr.push(parent);
      // }
      // if (item.children) {
      //   item.children.map((childItem) => {
      //     if (this.natureSecondLevel == childItem.id) {
      //       let children = {
      //         code: childItem.code,
      //         type: childItem.type,
      //       };
      //       arr.push(children);
      //     }
      //   });
      // }
      // });

      return arr;
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    getIndexTreeList(contentId) {
      manListContentIndexTree({ contentId: this.articelId }).then((res) => {
        console.log("res", res);
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.$parent.searchArticleById().then(() => {
          if (this.$parent?.res?.contentIndexes?.length > 0) {
            const treeToArr = (obj, arr) => {
              if (obj && obj.indexId) {
                arr.push(obj.indexId);
                treeToArr(obj.contentIndexes[0], arr);
              }
              if (
                !obj ||
                !obj.contentIndexes ||
                obj.contentIndexes.length === 0
              ) {
                return arr;
              }
            };
            if (this.$parent?.res?.contentIndexes?.length > 0) {
              const arr = [];
              treeToArr(this.$parent?.res.contentIndexes[0], arr);
              this.indexSelect = arr;
            }
          }
        });
        this.indexTreeList = res;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content-item p {
  width: 107px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;

  span {
    color: #f62458;
    margin-right: 5px;
  }
}

.radio-item {
  margin-left: 10px;
}

:deep(.content-item) {
  min-width: auto !important;
}
</style>
